// extracted by mini-css-extract-plugin
module.exports = {"listText":"Paragraph_listText__Dlq2k"};